<template>
  <el-drawer title="代理人详情" :visible.sync="drawer" direction="rtl" size="50%" @close="drawerClose(false)">
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      style="padding: 20px; background: #fff"
    >
      <el-tab-pane label="代理人信息" name="first">
        <el-form ref="editUserInfoForm" :model="editUserInfoForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="所属机构">
              <span style="color: #333333;font-weight: bolder;">{{reqData.agentName}}</span>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="机构ID">
              <span style="color: #333333;font-weight: bolder;">{{reqData.agentId}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="所属校区" prop="campusId">
              <el-cascader style="width:100%;" clearable v-model="editUserInfoForm.campusId" :show-all-levels="false" :props="CampusProps" placeholder="请选择所属校区" :options="campusList"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="代理姓名" prop="name">
              <el-input style="100%" v-model="editUserInfoForm.name" placeholder="请输入代理姓名" auto-complete="off" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="联系电话" prop="account">
              <el-input style="100%" v-model="editUserInfoForm.account" placeholder="请输入联系电话" auto-complete="new-account" maxlength="50"></el-input>
              <div>联系电话即为代理电话，初始密码默认123456</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="代理等级" prop="agentLevelId">
              <el-select style="width:100%" v-model="editUserInfoForm.agentLevelId">
                <el-option clearable v-for="i in organizations" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="是否启用" prop="enabled">
              <el-radio v-model="editUserInfoForm.enabled" label="1">启用</el-radio>
              <el-radio v-model="editUserInfoForm.enabled" label="0">禁用</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <el-button @click="cleareditUserInfoForm">重置</el-button>
              <el-button type="primary" @click="updateAgentUserInfo">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </el-tab-pane>
      <el-tab-pane label="余额充值" name="second">
        <el-row style="margin-left: 20px">
          <el-col :span="12">
            余额(元)
            <div style="font-size: 20px; margin-top: 10px">
              {{ editUserInfoForm.amount }}
            </div>
          </el-col>
          <el-col :span="12">
            消费(元)
            <div style="font-size: 20px; margin-top: 10px">
              {{ editUserInfoForm.consumptionAmount }}
            </div>
          </el-col>
        </el-row>
        <el-form
          :label-width="formLabelWidth"
          :model="addAgentAmount"
          :rules="addAgentAmountRules"
          ref="addAgentAmount"
        >
          <el-row :gutter="20">
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="充值金额" prop="amount">
                <el-input
                  v-model="addAgentAmount.amount"
                  type="number"
                  placeholder="请输入充值金额"
                >
                  <span slot="append">元</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="24" :lg="24">
              <el-form-item label="充值凭证" prop="attachmentList" class="drawerDetail">
                <el-upload
                  ref="upload"
                  action=""
                  :http-request="amountFileUploadRequest"
                  :on-remove="amountHandleRemove"
                  list-type="picture-card"
                >
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20"></el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label>
              <el-button
                type="primary"
                :loading="addAgentAmountLogBlock"
                @click="addAgentAmountLog"
                >提交
              </el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="充值记录" name="third">
        <el-row>
          <el-col :span="12">
            总消费金额
            <div style="font-size: 20px; margin-top: 10px">
              {{ editUserInfoForm.consumptionAmount }}
            </div>
          </el-col>
          <el-col :span="12">
            总充值金额
            <div style="font-size: 20px; margin-top: 10px">
              {{ editUserInfoForm.rechargeAmount }}
            </div>
          </el-col>
        </el-row>
        <el-table
          class="tableHeight"
          ref="multipleTable"
          :data="userInfoPage.rows"
          tooltip-effect="dark"
          style="margin-top: 20px; width: 100%"
          v-loading="userInfoPageLoading"
          border
        >
          <el-table-column
            show-overflow-tooltip
            prop="createTime"
            label="充值时间"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="userName"
            label="充值机构"
          ></el-table-column>
          <el-table-column show-overflow-tooltip prop="amount" label="充值金额(元)">
            <template slot-scope="row">
              <span v-if="row.row.amount >= 0">{{ row.row.amount }}</span>
              <span v-else style="color: red">{{ row.row.amount }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="operatorName"
            label="操作人"
          ></el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" label="充值凭证">
            <template slot-scope="row">
              <div
                v-if="row.row.attachmentList != null && row.row.attachmentList.length > 0"
              >
                <div>
                  <el-button type="text" @click="onPreview(row)" class="img"
                    >查看</el-button
                  >
                  <el-image-viewer
                    v-if="showViewer"
                    :on-close="closeViewer"
                    :url-list="urlList"
                  />
                </div>
              </div>
              <div v-else>{{ row.row.remark }}</div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          :pay-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          style="margin-top: 20px; text-align: right"
          :total="userInfoPage.total"
          :payPage-size="userInfoPage.pageSize"
          :current-payPage="userInfoPage.pageNumber"
          @size-change="userInfoSizeChange"
          @current-change="userInfoCurrentChange"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="消费记录" name="fourth">
        <el-table
          ref="multipleTable"
          :data="payPage.rows"
          class="tableHeight"
          style="width: 100%"
          border
        >
          <el-table-column
            show-overflow-tooltip
            prop="createTime"
            label="创建时间"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="amount"
            label="金额（元）"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="orderId"
            label="订单号"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="userName"
            label="操作人"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="remark"
            label="消费说明"
          ></el-table-column>
        </el-table>

        <el-pagination
          background
          :payPage-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          style="margin-top: 20px; text-align: right"
          :total="payPage.total"
          :payPage-size="payPage.pageSize"
          :current-payPage="payPage.pageNumber"
          @size-change="sizeChange"
          @current-change="currentChange"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { mapGetters } from "vuex";
import { uploadOSS } from "../../../upload/upload";
export default {
  components: { ElImageViewer },
  data() {
    return {
      payPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      id: "",
      activeName: "first",
      drawer: false,
      userInfoPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      editUserInfoForm: {
        campusId: "",
        shortName: "",
      },
      CampusProps: {
        value: "id",
        children: "children",
        label: "name",
      },
      campusList: [],
      organizations: [],
      userInfoPageLoading: false,
      addAgentAmountLogBlock: false,
      addAgentAmount: {
        type: "充值",
        objectType: 2,
        amount: null,
        attachmentList: [],
        remark: "",
        objectId: "",
      },
      agentInfoAmount: [],
      addAgentAmountRules: {
        amount: [
          {
            required: true,
            message: "请输入充值金额",
            trigger: "blur",
          },

          {
            pattern: /^\d+(\.\d{1,2})?$/,
            message: "充值金额小数点后不能超过二位",
          },
        ],
        attachmentList: {
          required: true,
          message: "请上传充值凭证",
          trigger: "change",
        },
      },
      addFormRules: {
        campusId: {
          required: true,
          message: "请选择所述校区",
          trigger: "change"
        },
        account: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur"
          },
          {
            min: 1,
            max: 11,
            message: "联系电话长度在1到11个字"
          },
          {
            pattern: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/,
            message: "联系电话格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入代理姓名",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "姓名长度在1到50个字"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "密码长度在1到50个字"
          }
        ],
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "blur"
        }
      },
      formLabelWidth: "80px",
      objectId: "",
      urlList: [],
      showViewer: false,
    };
  },

  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.loginData;
    },
    reqDatas () {
      return this.$store.state.user;
    }
  },
  methods: {
    init(row, activeName, campusList, organizations) {
      this.objectId = row.id;
      this.id = row.id;
      this.getAgentUserInfo();
      this.campusList = campusList;
      this.organizations = organizations;
      this.activeName = activeName;
      this.drawer = true;
    },
    // tab切换
    handleClick(tab, event) {
      if (tab.name == "first") {
      } else if (tab.name == "second") {
      } else if (tab.name == "third") {
        this.agentAmountLogPageList();
      } else if (tab.name == "fourth") {
        this.agentPayLogPageList();
      }
    },

    // 获取代理人详情
    getAgentUserInfo () {
      this.api.agentUserInfo.getAgentUserInfo({ id: this.id})
        .then(result => {
          this.editUserInfoForm = result.data;
          this.editUserInfoForm.enabled = String(this.editUserInfoForm.enabled);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 充值凭证上传
    amountFileUploadRequest(file) {
      const isJPG = file.file.type.indexOf("image") > -1;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
      } else {
        uploadOSS(file, "agentInfo").then((result) => {
          let obj = {
            name: file.file.name,
            size: file.file.size,
            type: file.file.type,
            url: result,
          };
          this.addAgentAmount.attachmentList.push(obj);
        });
      }
    },
    // 充值凭证移除
    amountHandleRemove(file) {
      for (let index in this.addAgentAmount.attachmentList) {
        if (
          file.name == this.addAgentAmount.attachmentList[index].name &&
          file.size == this.addAgentAmount.attachmentList[index].size
        ) {
          this.addAgentAmount.attachmentList.splice(index, 1);
        }
      }
    },
    // 充值
    addAgentAmountLog() {
      if (this.addAgentAmountLogBlock) {
        return false;
      }
      this.$refs.addAgentAmount.validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.addAgentAmountLogBlock = false;
          }, 5000);
          this.addAgentAmountLogBlock = true;
          this.addAgentAmount.objectId = this.objectId;
          this.api.agentInfo.addAgentAmountLogV2(this.addAgentAmount).then((result) => {
            if (result.success) {
              this.addAgentAmount.amount = "";
              this.addAgentAmount.remark = "";
              this.addAgentAmount.attachmentList = [];
              this.$refs.upload.clearFiles();
              this.$message.success(result.message);
              this.addAgentAmountLogBlock = false;
              this.drawerClose(true);
            } else {
              this.addAgentAmountLogBlock = false;
              this.$message.error(result.message);
            }
          });
        }
      });
    },
    // 查看
    onPreview(row) {
      this.urlList = [];
      row.row.attachmentList.forEach((e) => {
        this.urlList.push(e.url);
      });
      // this.urlList.push(row.row.attachmentList)
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    // 更新代理信息
    updateAgentUserInfo () {
      this.$refs.editUserInfoForm.validate(valid => {
        if (valid) {
          this.editUserInfoForm.agentId = this.loginData.agentId;
          this.api.agentUserInfo
            .updateAgentUserInfo(this.editUserInfoForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.drawerClose(true);
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    // 重置
    cleareditUserInfoForm() {
      this.editUserInfoForm.name = "";
      this.editUserInfoForm.parentId = "";
      this.editUserInfoForm.active = 1;
    },
    // 获取金额记录
    agentAmountLogPageList() {
      this.userInfoPageLoading = true;
      this.userInfoPage.rows = [];
      let obj = {
        pageNumber: this.userInfoPage.pageNumber,
        pageSize: this.userInfoPage.pageSize,
        objectType: 2,
        objectId: this.objectId,
        type: "充值",
      };
      this.api.agentUserInfo.agentAmountLogPageList(obj).then((result) => {
        if (result.success) {
          this.userInfoPage.rows = result.data.records;
          this.userInfoPage.total = result.data.total;
          this.userInfoPageLoading = false;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    // 关闭抽屉
    drawerClose(val) {
      this.$emit("drawerClose", val);
      this.drawer = false;
    },
    userInfoSizeChange(pageSize) {
      this.userInfoPage.pageSize = pageSize;
      this.agentAmountLogPageList();
    },
    userInfoCurrentChange(pageNumber) {
      this.userInfoPage.pageNumber = pageNumber;
      this.agentAmountLogPageList();
    },
    //消费记录-----------------------------------------------------
    agentPayLogPageList() {
      let obj = {
        pageNumber: this.payPage.pageNumber,
        pageSize: this.payPage.pageSize,
        objectType: 2,
        objectId: this.objectId,
        type: "消费",
      };
      this.api.agentAmountLog
        .pageList(obj)
        .then((result) => {
          this.payPage.rows = result.data.records;
          this.payPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sizeChange(pageSize) {
      this.payPage.pageSize = pageSize;
      this.agentPayLogPageList();
    },
    currentChange(pageNumber) {
      this.payPage.pageNumber = pageNumber;
      this.agentPayLogPageList();
    }
  },
};
</script>
<style lang="less">
::v-deep .drawerDetail {
  ::v-deep .el-upload-list {
    display: block !important;
  }
}
.el-image-viewer__wrapper {
  z-index: 3333 !important;
}
.tableHeight {
  height: 60vh;
}
</style>



// WEBPACK FOOTER //
// src/components/agentUserInfo/components/drawerDetail.vue